import { FormikErrors } from "formik";
import { Column } from "../../../../core/components/Column";
import { TextComponent } from "../../../../core/components/TextComponent";
import { CustomInput } from "../../../../core/components/CustomInput";

interface DateInputProps {
	name: string;
	value: string;
	setFieldValue: (field: string, value: any, shouldValidate?: boolean) => Promise<void | FormikErrors<any>>;
	handleBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
	placeholder: string;
}

export const DateInput: React.FC<DateInputProps> = ({ name, value, setFieldValue, handleBlur, placeholder }) => {
	return (
		<Column className="size-28">
			<TextComponent
				variant="h6"
				className="text-center mb-2 font-medium"
			>
				{placeholder}
			</TextComponent>
			<CustomInput
				name={name}
				value={value}
				onChange={(e) => {
					let inputValue = e.target.value.replace(/\D/g, "");
					if (placeholder === "YYYY") {
						if (inputValue.length <= 4) setFieldValue(name, inputValue);
					} else {
						if (inputValue.length > 2) inputValue = inputValue.slice(0, 2);
						setFieldValue(name, inputValue);
					}
				}}
				onBlur={(e) => {
					let inputValue = e.target.value;
					if (placeholder !== "YYYY" && inputValue.length === 1) {
						inputValue = `0${inputValue}`;
					}
					setFieldValue(name, inputValue);
					handleBlur(e);
				}}
				placeholder={placeholder}
				align="center"
				inputMode="numeric"
				pattern="[0-9]*"
			/>
		</Column>
	);
};
